import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import RefillLoop from './components/RefillLoop';
import Shop from './components/Shop';
import Impact from './components/Impact';
import InfoSection from './components/InfoSection';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import CheckoutFlow from './components/CheckoutFlow';
import { motion, AnimatePresence } from 'framer-motion';

function App() {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleAddToCart = (product) => {
    setCart(prev => {
      const existing = prev.find(item => item.id === product.id && item.scent === product.scent);
      if (existing) {
        return prev.map(item => item.id === product.id && item.scent === product.scent 
          ? { ...item, quantity: item.quantity + 1 } : item);
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const updateQuantity = (id, delta) => {
    setCart(prev => prev.map(item => item.id === id 
      ? { ...item, quantity: Math.max(1, item.quantity + delta) } : item));
  };

  const removeItem = (id) => {
    setCart(prev => prev.filter(item => item.id !== id));
  };

  const handleCheckoutComplete = () => {
    setCart([]);
    setIsCheckoutOpen(false);
    setIsCartOpen(false);
  };

  return (
    <div className="min-h-screen bg-[var(--off-white)] font-sans antialiased text-[var(--navy)] selection:bg-[var(--mint)] selection:text-[var(--navy)]">
      <Navbar cartCount={cart.reduce((a, b) => a + b.quantity, 0)} onCartOpen={() => setIsCartOpen(true)} />
      
      <main>
        <Hero />
        <RefillLoop />
        <Shop onAddToCart={handleAddToCart} />
        <Impact />
        <InfoSection />
      </main>

      <Footer />

      <CartDrawer 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
        cart={cart}
        updateQuantity={updateQuantity}
        removeItem={removeItem}
        onCheckout={() => {
          setIsCartOpen(false);
          setIsCheckoutOpen(true);
        }}
      />

      <CheckoutFlow 
        isOpen={isCheckoutOpen} 
        onClose={() => setIsCheckoutOpen(false)} 
        cart={cart}
        onComplete={handleCheckoutComplete}
      />
      
      <AnimatePresence>
        {showToast && (
          <motion.div 
            initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 50 }}
            className="fixed bottom-8 right-8 z-[150] bg-[var(--navy)] text-[var(--mint)] px-6 py-4 rounded-sm shadow-2xl flex items-center gap-4 border border-[var(--mint)]/20 cursor-pointer"
            onClick={() => { setIsCartOpen(true); setShowToast(false); }}
          >
            <div className="w-2 h-2 rounded-full bg-[var(--mint)] animate-pulse" />
            <p className="text-xs font-bold uppercase tracking-widest">Workspace Kit Updated • View Cart</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;